import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PAGE_LIMIT, ITEM_TEST_PACKAGE } from "../../constants/text_constants";
import LoadingLottie from "../Lottie-Components/LoadingLottie";
import { setAllTestsCache } from "../../configs/cache";
import CourseCard from "../Card-Component/CourseCard";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import { useNavigate } from "react-router-dom";
import userLogout from "../../utils/userLogout";
import IntegratedPagination from "../Pagination/IntegratedPagination";

const AllTestsList = () => {
  const [allTestsData, setAllTestsData] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const cache = useSelector((store) => store.cache.allTestsCache);
  const navigate = useNavigate();

  const fetchAllTests = async (retries = 6) => {
    try {
      const userAuthenticated = sessionStorage.getItem("authenticated") === "1";
      const authToken =
        sessionStorage.getItem("token") || process.env.REACT_APP_TEMP_TOKEN;
      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_ALL_TESTS_DATA + currentPage,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (!response.ok) {
        if (
          userAuthenticated &&
          response.status >= 400 &&
          response.status < 500
        ) {
          userLogout(navigate, dispatch, true);
        }
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchAllTests(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }
      const json = await response.json();
      setAllTestsData(json?.data);
      setTotalPages(Math.ceil(json?.data?.total / PAGE_LIMIT));
      dispatch(setAllTestsCache([json?.data, currentPage]));
    } catch (err) {
      console.error("Error fetchAllTests", err);
    }
  };

  useEffect(() => {
    if (cache[currentPage]) {
      setAllTestsData(cache[currentPage]);
      setTotalPages(Math.ceil(cache[currentPage]?.total / PAGE_LIMIT));
    } else {
      fetchAllTests();
    }
  }, [currentPage, cache]);

  if (!allTestsData || allTestsData?.test_packages.length === 0) {
    return <LoadingLottie />;
  }

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 lg:gap-8">
        {allTestsData?.test_packages.map((ele, i) => (
          <CourseCard
            key={i}
            name={ele?.name}
            offer_price={ele?.offer_price}
            offer_discount={ele?.offer_discount}
            price={ele?.price}
            course_banner={ele?.banner_url}
            title_1={"Duration"}
            value_1={ele?.duration}
            title_2={"Start Date"}
            value_2={ele?.starts_on}
            title_3={"End Date"}
            value_3={ele?.ends_on}
            title_4={"Validity"}
            value_4={ele?.validity}
            rating={ele?.rating}
            faculty_name={ele?.faculty_name}
            thumbnail={ele?.thumbnail}
            description={ele?.description}
            totalRating={ele?.total_rating}
            id={ele?.id}
            exploreMoreLink={UNPROTECTED_ROUTES?.testDetails}
            showPrice={true}
            showBuyNow={false}
            showExploreMore={true}
            showView={false}
            item={ITEM_TEST_PACKAGE}
            principal_amount={ele?.principal_amount}
          />
        ))}
      </div>
      <div className="my-[5rem]">
        <IntegratedPagination
          currentPage={currentPage + 1}
          totalPages={totalPages}
          setCurrentPage={(page) => setCurrentPage(page - 1)}
        />
      </div>
    </div>
  );
};

export default AllTestsList;
